
import { Component, Mixins } from "vue-property-decorator";
import { ITableScriptExecuteBehavior } from "../../../../../../documaker/domain/format/objects";
import { ITableScriptExecuteBehaviorPropertyEditable, instanceOfITableScriptExecuteBehaviorPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class TableScriptExecuteBehaviorPropertyEditableMixin extends Mixins() {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITableScriptExecuteBehaviorPropertyEditable) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITableScriptExecuteBehaviorPropertyEditable) => T, defaultValue: T) => T;

  // ドメイン層のエンティティは全てinterfaceにしてるが、
  // 本体のコンポーネントは従来のクラスエンティティで実装されてるのでそっちに合わせないと既存部品を再利用できない。
  // Vueの世界の話なのでコンポーネント側の実装で吸収する。

  get isTableScriptExecuteBehaviorEditable(): boolean {
    return this.readPropertyOrDefault(s => instanceOfITableScriptExecuteBehaviorPropertyEditable(s) && s.tableScriptExecuteBehavior().isEditable(), false);
  }

  get tableScriptExecuteBehavior(): ITableScriptExecuteBehavior {
    return this.readPropertyOrDefault(s => s.tableScriptExecuteBehavior().getValue(), { inputValuesCsvFilePathFormat: "", timing: 0, scriptPath: "", separator: "", parameters: [], csvFilePathFormat: "", valuesXmlPathFormat: "", previousValuesCsvFilePathFormat: "" });
  }

  set tableScriptExecuteBehavior(value: ITableScriptExecuteBehavior) {
    this.writePropertyWhenValid(s => s.tableScriptExecuteBehavior().setValue(value));
  }
}
